<template>
  <div>
    <ContentStatusManagementModal
      v-if="state.isShowModal"
      :status="status"
      :startPublish="startPublish"
      :endPublish="endPublish"
      :onClose="onCloseModal"
      :onChange="onChangeStatus" />
    <div class="status-container" @click="onShowModal" :class="{ disabled: disabled }">
      <div class="status-bullet-container">
        <div class="status-bullet" :class="status" />
      </div>
      <div class="status-wrapper">
        <div class="status">{{status}}</div>
        <small v-if="startPublish">เริ่มต้นเผยแพร่ :{{formatDateTime(startPublish)}} น.</small>
        <small v-if="endPublish">สิ้นสุดเผยแพร่ : {{formatDateTime(endPublish)}} น.</small>
      </div>
    </div>
  </div>
</template>

<script>
import dateFormatter from '@/utils/dateFormatter';
import ContentStatusManagementModal from './ContentStatusManagementModal.vue';

export default {
  mixins: [dateFormatter],
  components: {
    ContentStatusManagementModal,
  },
  props: {
    status: {
      type: String,
      default: 'draft',
    },
    startPublish: {
      type: [String, Date],
      default: null,
    },
    endPublish: {
      type: [String, Date],
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        isShowModal: false,
      },
    };
  },
  methods: {
    onShowModal() {
      this.state.isShowModal = true;
    },
    onCloseModal() {
      this.state.isShowModal = false;
    },
    onChangeStatus(newSchedule) {
      this.onChange(newSchedule);
      this.onCloseModal();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.disabled {
  pointer-events: none;
  background-color: #e9ecef !important;
  opacity: 1;
}

.status-container {
  display: flex;
  border: 1px solid $input-border-color;
  padding: $spacer * 0.3 $spacer * 0.5;
  border-radius: $input-border-radius;
  background-color: white;
  color: $gray-600;

  transition: all .2s ease-in-out;

  .status-bullet-container {
    margin-right: $spacer * 0.5;
    .status-bullet {
      margin-top: 5px;
      width: 8px;
      height: 8px;
      border-radius: 8px;
    }
    .published {
      background-color: $success;
    }
    .draft {
      background-color: $gray-500;
    }
    .scheduled {
      background-color: darken($warning, 3%);
    }
  }
  .status-wrapper {
    display: flex;
    flex-direction: column;
    .status {
      text-transform: uppercase;
    }
  }
}

.status-container:hover {
  cursor: pointer;
  background-color: #f5f5f5;
}
</style>
